(function(angular){
	'use strict';
	
	var portfolioAllocationChartViewMenuObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		require: {
			parent: '^portfolioAllocationByReitChart'
		},
		controller: [
			'$element',
			'$scope',
			'$window',
			'localStorageFactory',
			'mixpanelFactory',
			PortfolioAllocationChartViewMenuFunction
		],
		controllerAs: 'portfolioAllocationChartViewMenu'
	};
	
	angular
		.module('portfolioAllocationChartModule')
		.component('portfolioAllocationChartViewMenu', portfolioAllocationChartViewMenuObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/charts/portfolio-allocation/portfolio-allocation-chart-view-menu.html';
	}
	
	function PortfolioAllocationChartViewMenuFunction(
		$element,
		$scope,
		$window,
		localStorageFactory,
		mixpanelFactory){
		var portfolioAllocationChartViewMenu = this;
		var viewModeAlertKey = 'com.fundrise.dashboard.portfolioAllocationByReitChart.viewModeAlertDismissed';

		portfolioAllocationChartViewMenu.visible = false;
		portfolioAllocationChartViewMenu.hasDismissedAlert = true;

		portfolioAllocationChartViewMenu.ignoreClose = function($event) {
			if ($event.stopPropagation) {
				$event.stopPropagation();
			}
		};

		portfolioAllocationChartViewMenu.setUpClose = function() {
			var page = angular.element($window);
			var element = $element[0];
			page.bind('click', function(event) {

				if(portfolioAllocationChartViewMenu.visible) {
					var ignoreClose = false;

					angular.forEach(event.path, function(domNode) {
						if(domNode === element) {
							ignoreClose = true;
						}
					});

					if(!ignoreClose) {
						portfolioAllocationChartViewMenu.visible = false;
						$scope.$apply();
					}
				}
			});
		};

		portfolioAllocationChartViewMenu.toggle = function($event) {
			if (angular.isDefined($event)) {
				$event.stopPropagation();
			}

			if(!portfolioAllocationChartViewMenu.hasDismissedAlert) {
				portfolioAllocationChartViewMenu.dismissAlert();
			}
			portfolioAllocationChartViewMenu.visible = !portfolioAllocationChartViewMenu.visible;
			portfolioAllocationChartViewMenu.setUpClose();
		};

		portfolioAllocationChartViewMenu.dismissAlert = function() {
			localStorageFactory.setItem(viewModeAlertKey, true);
			portfolioAllocationChartViewMenu.hasDismissedAlert = true;
			mixpanelFactory.track('Portfolio Allocation Chart - Dismissed View Mode Alert');
		};

		portfolioAllocationChartViewMenu.$onInit = function() {
			var hasDismissedAlert = localStorageFactory.getItem(viewModeAlertKey);
			if(angular.isUndefined(hasDismissedAlert)) {
				portfolioAllocationChartViewMenu.hasDismissedAlert = false;
			}
		};
	}
})(window.angular);